export default __webpack_public_path__ + "static/media/sticker-animation-dark@2x.e08a946c.webp";